import moment from 'moment';
import ReactDatetime from 'react-datetime';

const ReactDatetimeClass = ReactDatetime as any;

type WeekPickerProps = {
  value: string | null;
  onChange: (weekStart: string) => void;
  placeholder?: string;
  dateFormat?: string;
  maxWidth?: string;
  showInterval?: boolean;
  intervalLabel?: string;
};

const WeekPicker = ({
  value,
  onChange,
  placeholder = 'Select the Monday (start of the week)',
  dateFormat = 'DD/MM/YYYY',
  maxWidth = '400px',
  showInterval = true,
  intervalLabel = 'Interval:',
}: WeekPickerProps) => {
  const handleChange = (dateValue: moment.Moment | string) => {
    if (!dateValue) return;
    const monday = moment(dateValue).startOf('isoWeek').format('YYYY-MM-DD');
    onChange(monday);
  };

  const isValidDate = (current: moment.Moment) => {
    return moment(current).isoWeekday() === 1;
  };

  const getIntervalText = () => {
    if (!value) return '—';
    const startFormatted = moment(value).format('MM/DD/YYYY');
    const endFormatted = moment(value).endOf('isoWeek').format('MM/DD/YYYY');
    return `${startFormatted} » ${endFormatted}`;
  };

  return (
    <div style={{ maxWidth }}>
      <ReactDatetimeClass
        inputProps={{ placeholder }}
        value={value ? moment(value) : ''}
        onChange={handleChange}
        timeFormat={false}
        dateFormat={dateFormat}
        closeOnSelect
        isValidDate={isValidDate}
      />
      {showInterval && (
        <small className="text-muted mt-1 d-block">
          {intervalLabel} {getIntervalText()}
        </small>
      )}
    </div>
  );
};

export default WeekPicker;
